var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Select',{attrs:{"label":_vm.label,"value":_vm.value,"disabled":_vm.disabled,"options":_vm.options},on:{"update:value":function($event){return _vm.$emit('update:value', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }